import Draggable from "react-draggable";
import {useState} from "react";
import Modal from 'react-modal';
import {PlanItemModal} from "./modals";
import {v4 as uuidv4} from "uuid";
import {Config, Helpers} from "../utils";


export default function DraggableItem(props) {
  const [modalVisible, setModalVisible] = useState(false);
  const [editCustomElementModalVisible, setEditCustomElementModalVisible] = useState(false);
  const [customElement, setCustomElement] = useState(null)
  const [dragging, setDragging] = useState(false);

  const isSelectedProductOfTypeBorder = ['barierka', 'deska_okalajaca', 'listwa_odbojowa'].includes(props.selectedProduct?.type)

  const openModal = () => {
    setModalVisible(true);
  }

  const closeModal = () => {
    props.cancelActions();
    setModalVisible(false)
  }

  const onDelete = () => {
    setModalVisible(false);
    props.onDelete();
  }

  const onClick = (e, place = undefined) => {
    if(props.showPlacements && props.item.product.id && !props.selectedProduct.type.startsWith('panel')) {
      if(isSelectedProductOfTypeBorder && !place)
        return;
      if(!isSelectedProductOfTypeBorder && place)
        return;

      const element = {
        id: uuidv4(),
        value: 1,
        place,
        product: props.selectedProduct,
        elements: [
          {
            type: 'gate',
            width: 0
          }
        ],
      }
      const arr = [...props.item.elements];
      arr.push(element);
      props.editCustomElements(arr);
    } else if(props.deletionMode && !place) {
      props.onDelete();
    }
  }

  const onClickElement = (element, e = null) => {
    if(props.deletionMode && !props.selectedProduct) {
      const arr = [...props.item.elements];
      const idx = arr.findIndex(i => i.id === element.id && i.place === element.place);
      if(idx !== -1) {
        arr.splice(idx, 1);
        props.editCustomElements(arr);
      }
    } else {
      if(e?.target?.className?.split(' ')?.includes('planItem__barItem')) {
        setEditCustomElementModalVisible(true)
        setCustomElement(element)
      }
    }
  }

  const handleChangeCustomElementGateWidth = (e) => {
    const value = e?.target?.value
    if(value) {
      const arr = [...props.item.elements];
      const idx = arr.findIndex(i => i.id === customElement.id && i.place === customElement.place);
      if(idx !== -1) {
        const cArr = [...arr[idx].elements];
        const cIdx = cArr.findIndex(i => i.type === 'gate');
        if(cIdx !== -1) {
          cArr[cIdx].width = value
          arr[idx].elements = cArr
          props.editCustomElements(arr);
          setEditCustomElementModalVisible(false)
        }
      }
    }
  }

  const onDrag = (e, data) => {}


  const topElements = props.item.elements.filter(el => el.place === 'top');
  const rightElements = props.item.elements.filter(el => el.place === 'right');
  const bottomElements = props.item.elements.filter(el => el.place === 'bottom');
  const leftElements = props.item.elements.filter(el => el.place === 'left');
  const undefinedElements = props.item.elements.filter(el => el.place === undefined);

  const EditTextBorder = () => (
    props.showPlacements
    && isSelectedProductOfTypeBorder
    && !props.selectedProduct.type.startsWith('panel')
    && <div className="planItem__editText"><span>Hier hinzufügen</span></div>
  )

  const options = []
  props.elements.filter(e => e.product?.type === 'panel').map(e => {
    if(!options.includes(Number(e.product.width)))
      options.push(Number(e.product.width))
    if(!options.includes(Number(e.product.height)))
      options.push(Number(e.product.height))
  })
  options.sort((a, b) => a > b ? 1 : -1)

  return (
    <Draggable
      offsetParent={document.getElementById('draggablePlanWrapper')}
      bounds="parent"
      grid={[10, 10]}
      onStart={() => setDragging(true)}
      onStop={() => setDragging(false)}
      onDrag={onDrag}
      defaultPosition={{x: props.item.x ?? 0, y: props.item.y ?? 0}}
      disabled={props.disabled}
      scale={props.scale}
      cancel=".planItem__openModalButton,.planItemElement,.planItem__barItemContent"
    >

      <div
        id={`planItem_${props.item.id}`}
        className="planItem"
        style={{
          position: 'absolute',
          top: 0,
          left: 0,
          // backgroundColor: '#e3e3e3e3',
          // border: '1px solid black',
          width: props.item.product.width * 0.8,
          height: props.item.product.height * 0.8,
          zIndex: dragging ? 5000 : undefined,
        }}
      >
        <div style={{padding: 1, height: '100%'}}>
          <div
            className="planItem__content"
            style={{
              borderTopWidth: topElements.length ? 0 : undefined,
              borderRightWidth: rightElements.length ? 0 : undefined,
              borderBottomWidth: bottomElements.length ? 0 : undefined,
              borderLeftWidth: leftElements.length ? 0 : undefined,
            }}
          >
            <div style={{flex: 1, display: 'grid', alignItems: 'center', gridArea: 'content'}} onClick={onClick}>
              <p
                style={{display: 'inline-block', fontSize: 11, lineHeight: 1}}
                data-tip={props.item.product.name}
                data-effect="solid"
                data-place="right"
              >
                {getTypeName(props.item?.product.type)}
              </p>
              <div className="planItem__dimensions">{props.item?.product.width}x{props.item?.product.height}x{props.item?.product.depth}cm</div>

              {props.showPlacements
              && !isSelectedProductOfTypeBorder
              && !props.selectedProduct.type.startsWith('panel') && (
                <div className="planItem__editText">Hier hinzufügen</div>
              )}
              {/*{!!(props.item.product.id && props.showPlacements && props.selectedProduct?.type !== 'panel') && (*/}
              {/*  <p style={{textAlign: 'center'}}><strong>Kliknij tutaj aby dodać</strong></p>*/}
              {/*)}*/}
            </div>


            <div
              className={`planItem__bar -top ${props.showPlacements && isSelectedProductOfTypeBorder ? '-active' : ''}`}
              style={{gridArea: 'top'}}
              onClick={e => onClick(e, 'top')}
            >
              {topElements.map((el, idx) => (
                <div
                  key={el.id}
                  className="planItem__barItem"
                  style={{height: 3, marginRight: 5 * idx, marginLeft: 5 * idx, background: Helpers.getColorByType(el.product.type)}}
                  data-tip={`${el.product.name} - ${el.value}x`}
                  data-effect="solid"
                  data-place="right"
                  onClick={e => onClickElement(el, e)}
                >
                  {el.elements?.filter(i => i.width > 0).map((cel, celIdx) => (
                    <Draggable
                      key={celIdx}
                      offsetParent={document.getElementById(`planItem_${props.item.id}`)}
                      bounds="parent"
                      defaultPosition={{x: 0, y: 0}}
                      // grid={[10, 10]}
                      disabled={props.deletionMode}
                      scale={props.scale}
                    >
                      <div className="planItem__barItemContent" style={{width: Number(cel.width)}}/>
                    </Draggable>
                  ))}
                </div>
              ))}
              <EditTextBorder/>
            </div>
            <div
              className={`planItem__bar -right ${props.showPlacements && isSelectedProductOfTypeBorder ? '-active' : ''}`}
              style={{gridArea: 'right'}}
              onClick={e => onClick(e, 'right')}
            >
              {rightElements.map((el, idx) => (
                <div
                  key={el.id}
                  className="planItem__barItem"
                  style={{width: 3, marginTop: 5 * idx, marginBottom: 5 * idx, background: Helpers.getColorByType(el.product.type)}}
                  data-tip={el.product.name}
                  data-effect="solid"
                  data-place="right"
                  onClick={e => onClickElement(el, e)}
                >
                  {el.elements?.filter(i => i.width > 0).map((cel, celIdx) => (
                    <Draggable
                      key={celIdx}
                      offsetParent={document.getElementById(`planItem_${props.item.id}`)}
                      bounds="parent"
                      defaultPosition={{x: 0, y: 0}}
                      // grid={[10, 10]}
                      disabled={props.deletionMode}
                      scale={props.scale}
                    >
                      <div className="planItem__barItemContent" style={{height: Number(cel.width)}}/>
                    </Draggable>
                  ))}
                </div>
              ))}
              <div style={{writingMode: 'vertical-rl'}}>
                <EditTextBorder/>
              </div>
            </div>

            <div
              className={`planItem__bar -bottom ${props.showPlacements && isSelectedProductOfTypeBorder ? '-active' : ''}`}
              style={{gridArea: 'bottom'}}
              onClick={e => onClick(e, 'bottom')}
            >
              {bottomElements.map((el, idx) => (
                <div
                  key={el.id}
                  className="planItem__barItem"
                  style={{height: 3, marginLeft: 5 * idx, marginRight: 5 * idx, background: Helpers.getColorByType(el.product.type)}}
                  data-tip={el.product.name}
                  data-effect="solid"
                  data-place="right"
                  onClick={e => onClickElement(el, e)}
                >
                  {el.elements?.filter(i => i.width > 0).map((cel, celIdx) => (
                    <Draggable
                      key={celIdx}
                      offsetParent={document.getElementById(`planItem_${props.item.id}`)}
                      bounds="parent"
                      defaultPosition={{x: 0, y: 0}}
                      // grid={[10, 10]}
                      disabled={props.deletionMode}
                      scale={props.scale}
                    >
                      <div className="planItem__barItemContent" style={{width: Number(cel.width)}}/>
                    </Draggable>
                  ))}
                </div>
              ))}
              <EditTextBorder/>
            </div>
            <div
              className={`planItem__bar -left ${props.showPlacements && isSelectedProductOfTypeBorder ? '-active' : ''}`}
              style={{gridArea: 'left'}}
              onClick={e => onClick(e, 'left')}
            >
              {leftElements.map((el, idx) => (
                <div
                  key={el.id}
                  className="planItem__barItem"
                  style={{width: 3, marginTop: 5 * idx, marginBottom: 5 * idx, background: Helpers.getColorByType(el.product.type)}}
                  data-tip={el.product.name}
                  data-effect="solid"
                  data-place="right"
                  onClick={e => onClickElement(el, e)}
                >
                  {el.elements?.filter(i => i.width > 0).map((cel, celIdx) => (
                    <Draggable
                      key={celIdx}
                      offsetParent={document.getElementById(`planItem_${props.item.id}`)}
                      bounds="parent"
                      defaultPosition={{x: 0, y: 0}}
                      // grid={[10, 10]}
                      disabled={props.deletionMode}
                      scale={props.scale}
                    >
                      <div className="planItem__barItemContent" style={{height: Number(cel.width)}}/>
                    </Draggable>
                  ))}
                </div>
              ))}
              <div style={{writingMode: 'vertical-lr'}}>
                <EditTextBorder/>
              </div>
            </div>


            {undefinedElements.map((el, idx) => (
              <Draggable
                key={el.id}
                offsetParent={document.getElementById(`planItem_${props.item.id}`)}
                bounds="parent"
                defaultPosition={{x: 0, y: 0}}
                grid={[10, 10]}
                disabled={props.deletionMode}
                scale={props.scale}
              >
                <div
                  className="planItemElement"
                  style={{backgroundImage: `url(${Helpers.getIconByType(el.product.type)})`}}
                  data-tip={el.product.name}
                  data-effect="solid"
                  data-place="right"
                  onClick={() => onClickElement(el)}
                />
              </Draggable>
            ))}
          </div>

          {/*<div style={{position: 'absolute', top: 0, right: 0, bottom: 0, left: 0, padding: 5, zIndex: 1}}>*/}
          {/*  */}
          {/*</div>*/}
        </div>

        {!!props.item.product.id && (
          <>
            <PlanItemModal
              visible={modalVisible}
              item={props.item}
              showPlacements={props.showPlacements}
              selectedProduct={props.selectedProduct}
              editCustomElements={props.editCustomElements}
              onDelete={onDelete}
              onClose={closeModal}
            />

            <Modal
              isOpen={editCustomElementModalVisible}
              onRequestClose={() => setEditCustomElementModalVisible(false)}
            >
              <div style={{maxWidth: 600, margin: '0 auto'}}>
                <h4>Dodaj wnękę</h4>
                <hr/>
                {!!customElement && (
                  <div className="mb-3">
                    <select
                      className="form-control"
                      value={customElement.elements.find(i => i.type === 'gate')?.width}
                      onChange={handleChangeCustomElementGateWidth}
                    >
                      <option value={0}>{0}</option>
                      <option value={100}>{100}</option>
                      <option value={150}>{150}</option>
                      <option value={200}>{200}</option>
                      <option value={300}>{300}</option>
                      {/*{options.map(value => (*/}
                      {/*  <option key={value} value={value}>{value}</option>*/}
                      {/*))}*/}
                    </select>
                  </div>
                )}
                <hr/>
                <button type="button" className="btn btn-secondary" onClick={() => setEditCustomElementModalVisible(false)}>Zamknij</button>
              </div>
            </Modal>
          </>
        )}
      </div>
    </Draggable>
  )
}


function getTypeName(type) {
  return Config.types[type];
}
